import { render, staticRenderFns } from "./SmsBuilder.vue?vue&type=template&id=50819d56&scoped=true"
import script from "./SmsBuilder.vue?vue&type=script&lang=js"
export * from "./SmsBuilder.vue?vue&type=script&lang=js"
import style0 from "./SmsBuilder.vue?vue&type=style&index=0&id=50819d56&prod&lang=scss"
import style1 from "./SmsBuilder.vue?vue&type=style&index=1&id=50819d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50819d56",
  null
  
)

export default component.exports